import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { BridgeMark, BrandWordmark } from "./BridgeMotif";

export function Footer() {
  const { t } = useLang();
  const legal = [
    { to: "/legal/privacidad", label: t("footer.privacy"), testId: "footer-privacy" },
    { to: "/legal/terminos", label: t("footer.terms"), testId: "footer-terms" },
    { to: "/legal/aviso", label: t("footer.disclaimer"), testId: "footer-disclaimer" },
    { to: "/legal/derechos", label: t("footer.copyright"), testId: "footer-copyright" },
  ];
  return (
    <footer className="mt-24 border-t border-border bg-white" data-testid="global-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <BridgeMark size={28} />
              <BrandWordmark className="text-lg" />
            </div>
            <p className="mt-3 font-display text-sm italic text-terracotta">{t("brand.tagline")}</p>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{t("footer.tagline")}</p>
            <p className="mt-4 text-xs text-muted-foreground">{t("footer.owned")}</p>
            <p className="mt-1 text-xs text-muted-foreground">conquienhoy.com</p>
          </div>
          <div className="md:justify-self-end">
            <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{t("footer.legal")}</p>
            <ul className="mt-4 space-y-2.5">
              {legal.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={l.testId}
                    className="text-sm text-slateink/80 transition-colors hover:text-terracotta"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 rounded-xl border border-border bg-cream px-5 py-4">
          <p className="text-xs leading-relaxed text-muted-foreground">{t("footer.disclaimer_short")}</p>
        </div>

        <p className="mt-8 text-xs text-muted-foreground">{t("footer.rights")}</p>
      </div>
    </footer>
  );
}
